import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" {...props}><text transform="translate(24 48)" fill="#4197e3" fontSize="48" fontFamily="MaterialIcons-Regular, Material Icons"><tspan x="-24" y="0">check_circle</tspan></text></svg>);